import { Component, Input } from '@angular/core';
import { COMMON_MODULES } from '@src/app/core/constants';

@Component({
  selector: 'app-mini-env-content-box',
  imports: [...COMMON_MODULES],
  templateUrl: './mini-env-content-box.component.html',
  styleUrl: './mini-env-content-box.component.scss'
})
export class MiniEnvContentBoxComponent {
  @Input() imgSrc: string = '';
  @Input() imgSrcMobile: any;
}
